import moment from 'moment';
import { utcToLocal } from '../../../legacy/utils/helpers';

// Update the locale for relative time formatting
moment.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'a second',
    ss: '%dsec',
    m: 'a minute',
    mm: '%d min',
    w: '1 week',
    ww: '%dw',
    h: 'an hour',
    hh: '%d h',
    d: 'a day',
    dd: '%d days',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%dy',
  },
});

export const getRelativeTime = (date: string): string => {
  return utcToLocal(date).fromNow();
};